import { render } from "./deals-notes.vue?vue&type=template&id=47f6c23c"
import script from "./deals-notes.vue?vue&type=script&lang=js"
export * from "./deals-notes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__